import React, { useState } from 'react'
import PlansPage from '../plan/PlansPage';
import LinkPage from './LinkPage';
import { useSelector } from 'react-redux';
import { FaCreditCard } from 'react-icons/fa';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';


export default function ShortLink() {
    const [showPlanPage, setShowPlanPage] = useState(false);
    const linkData = useSelector((state) => state.linkList.data);

    const totalLinks = linkData?.length || 0;
    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <div className='layout d-flex justify-content-between align-items-center'>
                            <h5>Short Link</h5>
                            <div className='d-flex align-items-center'>
                                <div>
                                    <span className="bg-primary text-white p-2 rounded me-3">
                                        Total: {totalLinks}
                                    </span>
                                </div>
                                <Link to="/plans" className="">
                                    <Button
                                        variant="warning"
                                        className="d-flex align-items-center gap-2 buy-links-btn "
                                        style={{
                                            fontWeight: 500
                                        }}
                                    >
                                        <FaCreditCard size={18} />
                                        <span className="btn-text">Buy Links</span>
                                    </Button>
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <LinkPage setShowPlanPage={setShowPlanPage} />
                    </div>

                    {!showPlanPage && (
                        <>
                            {/* <div className="col-md-12 mt-3 mb-2">
                                <div className='layout'>
                                    <h5>Plans</h5>
                                </div>
                            </div> */}
                            {/* <div className="col-md-12"> */}
                            <PlansPage showPlanPage={showPlanPage} />
                            {/* </div> */}
                        </>
                    )}
                </div>
            </div>
         
        </>
    )
}
